module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-20-86528959c2598f42092537be35de4609.jpg";